export const FGWEBSHOP_DEPLOY_STATUS_NOT_DEPLOYED = 0;
export const FGWEBSHOP_DEPLOY_STATUS_DEPLOY_STARTED = 1;
export const FGWEBSHOP_DEPLOY_STATUS_INSTANCE_CREATED = 4;
export const FGWEBSHOP_DEPLOY_STATUS_INSTANCE_RUNNING = 5;
export const FGWEBSHOP_DEPLOY_STATUS_INSTANCE_DEACTIVATED = 6;
export const FGWEBSHOP_DEPLOY_STATUS_INSTANCE_STOPPED = 98;
export const FGWEBSHOP_DEPLOY_STATUS_ERROR = 99;
